












































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import MonitoringTransportEksternalSvc from "@/services/MonitoringTransportEksternalService";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { appModule } from "@/store/modules/app";
import { storeFaskes } from "@/store/modules/faskes";
import {
  composeDate,
  toDateString,
  toTimeString
} from "@/utils/asesmenIntensifDateTime";
import {
  maskTekananDarah,
  validasiTekananDarah
} from "@/utils/tekananDarah";
import moment from "moment";

@Component({ components: { VCDateTimePicker } })
export default class MonitoringTransportEksternalForm extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: null }) editData!: any;
  @Prop({ default: false }) readonly!: boolean;

  saving = false;
  kesadaranOptions = ["CM", "Somnolen", "Apatis", "Coma"];
  form: any = this.getEmptyForm();

  get isEdit() {
    return this.editData && this.editData.id;
  }

  get isValid() {
    return !!this.form.faskes_tujuan;
  }

  get waktuTransport(): Date | null {
    return composeDate(this.form.tanggal, this.form.jam);
  }

  set waktuTransport(val: Date | null) {
    this.form.tanggal = toDateString(val) || "";
    this.form.jam = toTimeString(val);
  }

  get waktuTiba(): Date | null {
    return composeDate(this.form.tiba_tanggal, this.form.tiba_jam);
  }

  set waktuTiba(val: Date | null) {
    this.form.tiba_tanggal = toDateString(val) || "";
    this.form.tiba_jam = toTimeString(val);
  }

  get tdRules() {
    return [(v: string) => validasiTekananDarah(v)];
  }

  onTdAwal(val: string) {
    this.form.td_awal = this.terapkanMaskerTd(
      val,
      this.form.td_awal,
      "tdAwalRef"
    );
  }

  onTdTiba(val: string) {
    this.form.td_tiba = this.terapkanMaskerTd(
      val,
      this.form.td_tiba,
      "tdTibaRef"
    );
  }

  private terapkanMaskerTd(val: string, sebelumnya: string, ref: string) {
    const bersih = maskTekananDarah(val, sebelumnya);

    if (bersih !== val) {
      const field = this.$refs[ref] as { lazyValue?: string };
      if (field) field.lazyValue = bersih;
    }

    return bersih;
  }

  // Master faskes (ref_faskes). Nilai teks bebas lama tetap ditampilkan sebagai item
  // agar data tersimpan tidak hilang saat form dibuka kembali.
  get faskesItems() {
    const list = (storeFaskes.faskes || []).map((f: any) => ({ nama: f.nama }));
    const current = this.form.faskes_tujuan;
    if (current && !list.some((f: any) => f.nama === current)) {
      list.unshift({ nama: current });
    }
    return list;
  }

  mounted() {
    if (!storeFaskes.faskes.length) {
      storeFaskes.act_all();
    }
    if (this.editData) {
      this.populateForm(this.editData);
    }
  }

  @Watch("editData")
  onEditDataChanged(val: any) {
    if (val) {
      this.populateForm(val);
    } else {
      this.form = this.getEmptyForm();
    }
  }

  getEmptyForm() {
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      tanggal: moment().format("YYYY-MM-DD"),
      jam: moment().format("HH:mm"),
      faskes_tujuan: "",
      petugas1_nama: "",
      petugas2_nama: "",
      diagnosa: "",
      kondisi_klinis_awal: "",
      kesadaran_awal: "",
      catatan_awal: "",
      td_awal: "",
      nadi_awal: "",
      respirasi_awal: "",
      suhu_awal: "",
      asesmen_transport: "",
      tindakan_transport: "",
      tiba_tanggal: "",
      tiba_jam: "",
      kondisi_klinis_tiba: "",
      kesadaran_tiba: "",
      catatan_tiba: "",
      td_tiba: "",
      nadi_tiba: "",
      respirasi_tiba: "",
      suhu_tiba: "",
      penerima_nama: "",
      petugas_transportasi_nama: "",
    };
  }

  populateForm(data: any) {
    const empty = this.getEmptyForm();
    const next: any = { ...empty };
    Object.keys(empty).forEach(k => {
      if (data[k] !== undefined && data[k] !== null) {
        next[k] = data[k];
      }
    });
    next.register_id = data.register_id || this.register;
    next.pasien_rm = data.pasien_rm || this.rm;
    // Normalise time columns to HH:mm for the native time input
    next.jam = data.jam ? String(data.jam).slice(0, 5) : "";
    next.tiba_jam = data.tiba_jam ? String(data.tiba_jam).slice(0, 5) : "";
    this.form = next;
  }

  async simpan() {
    this.saving = true;
    try {
      let resp;
      if (this.isEdit) {
        resp = await MonitoringTransportEksternalSvc.update(this.editData.id, this.form);
      } else {
        resp = await MonitoringTransportEksternalSvc.create(this.form);
      }
      if (resp.data.status == "1") {
        appModule.NoticeDelay(this.isEdit ? "Berhasil diupdate" : "Berhasil disimpan");
        this.$emit("saved", resp.data.data);
      }
    } catch {
      // handled by service
    }
    this.saving = false;
  }
}
